module.exports = __webpack_public_path__ + "static/media/Safe.acad16bd.png";